import React from 'react';
import EnvironmentDetection from '../lib/EnvironmentDetection';

// React throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
export const useIsomorphicLayoutEffect = EnvironmentDetection.isBrowser ? React.useLayoutEffect : React.useEffect;
